/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React from "react";
import { shouldRenderDiv, addHeaderTagIfMissing } from "../buyingGuideHelpers";
import { BuyingGuideSection } from "../Types/BuyingGuideSection";

export default function BuyingGuideTextImageHighlight({
  section,
}: {
  section: BuyingGuideSection;
}) {
  return (
    <div className="guide-section textimage-highlight-template">
      <div className="flex-container">
        <div
          className={`highlight-module highlight ${section.contents.length}`}
        >
          {section.contents.map((content, index) => (
            <div className="highlight-item" key={`highlight-${index}`}>
              <div className="template-image">
                {content.imageLink.length > 0 && (
                  <a href={content.imageLink}>
                    <img src={content.imageUrl} alt="Restaurant Equipment" />
                  </a>
                )}
                {content.imageLink.length === 0 && (
                  <img src={content.imageUrl} alt="Restaurant Equipment" />
                )}
              </div>
              <div className="template-text">
                {shouldRenderDiv(content.heading) && (
                  <div
                    className="item-header"
                    dangerouslySetInnerHTML={{
                      __html: addHeaderTagIfMissing(content.heading, "p"),
                    }}
                  />
                )}
                {shouldRenderDiv(content.htmlContent) && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: content.htmlContent,
                    }}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
